export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      gap: 2,
      flexDirection: 'column',
    },
  };
};
